export enum CacheKeys {
    Basket = '/baskets/summary',
    Delivery = '/delivery',

    FavoriteStore = '/stores/favorite',
    SelectedStore = '/stores/selected',

    NotifyMe = '/notify-me',
    ProductDeliveryInfo = '/product-delivery-info',
    UserRecommendations = '/user/recommendations',
    ProductRecommendations = '/product-recommendations',
    ProductSetInfo = '/product-set-info',
    Products = '/products',
    Promotion = '/promotion-infos',
    UnusedKey = '/unused', // DO NOT USE THIS KEY FOR REVALIDATION
    User = '/user',
    Wishlist = '/wishlists/summary',

    ContentAsset = '/content-asset',
    NotifyMeAsset = '/content-asset/notify-me',
    PriceRegulationAsset = '/content-asset/price-regulation',
    LegalMentionsAsset = '/content-asset/legal-mentions',
    EngravingForm = '/form/engraving',
    RatingReviewForm = '/form/rating-review',

    ReviewTranslation = '/review/translation',
    PotionCookie = '/potion/cookie',
}
